// extracted by mini-css-extract-plugin
export var headerContainer = "HeaderTemplate-module--headerContainer--5614f";
export var headerContent = "HeaderTemplate-module--headerContent--89682";
export var headerMiddleBar = "HeaderTemplate-module--headerMiddleBar--714eb";
export var logoContainer = "HeaderTemplate-module--logoContainer--a66d4";
export var logoDesktop = "HeaderTemplate-module--logoDesktop--3aa06";
export var logoMobile = "HeaderTemplate-module--logoMobile--bae89";
export var primaryNavContainer = "HeaderTemplate-module--primaryNavContainer--8e528";